import { appMethod as app } from '@utils/app';
import { getCurrentPageQueryParams } from '@utils/tools';

import { ScrollView } from 'src/jisu-component/scroll-view/ScrollView';
import { TopNav } from '@common/top-nav/TopNav';
import OfficialPage from '../OfficialPage';

import './MyFormMessage.less';

export default class MyFormMessage extends OfficialPage {
  state = {
    messageType: 5, // 5:默认展示系统消息列表
    systemBranch: {
      data: [],
      isMore: 0,
      currentPage: 1,
      onload: false,
      unreadCount: 0
    },
    interactBranch: {
      data: [],
      isMore: 0,
      currentPage: 1,
      onload: false,
      unreadCount: 0
    },
    pushBranch: {
      data: [],
      isMore: 0,
      currentPage: 1,
      onload: false,
      unreadCount: 0
    },
    messageDetail: 0, // 控制是否展开 0:不展示消息详情页 3:展示表单详情页
    messageDetailFormData: [], //消息详情页：表单数据
    review_switch: 0 //  表单是否开启审核
  }

  constructor(props) {
    super(props);
    document.title = '表单提交信息';
  }

  componentWillMount(options = getCurrentPageQueryParams()) {
    this.options = options
    this.getReviewConfig()
    if (options.from === 'transforDetail') {
      this.setData({
        messageDetail: 3
      })
      this.showMessageDetailForm({
        currentTarget: {
          dataset: {
            form: options.form,
            formDataId: options.formDataId,
            formId: options.formid
          }
        }
      })
    } else {
      this.getMessageData()
    }
  }

  getMessageData = (type, page) => {
    let that = this
    app.sendRequest({
      url: '/index.php?r=AppNotify/GetUserAppNotifyMsg',
      data: {
        app_id: app.globalData.appId,
        types: type || '5,6,16',
        page: page || ''
      },
      success: function (res) {
        for (var key in res.data) {
          switch (parseInt(key)) {
            case 5:
              that.setData({
                'systemBranch.data': that.data.systemBranch.data
                  ? that.data.systemBranch.data.concat(
                    that.parseMessageData(res.data[key].data)
                  )
                  : that.parseMessageData(res.data[key].data),
                'systemBranch.isMore': res.data[key].is_more || '',
                'systemBranch.currentPage': res.data[key].current_page || '',
                'systemBranch.onload': false,
                'systemBranch.unreadCount': res.data[key].unread_count || ''
              })
              break
          }
        }
      }
    })
  }
  parseMessageData = data => {
    let array = []
    let contentJson
    let item
    for (var i = 0; i < data.length; i++) {
      switch (parseInt(data[i].type)) {
        case 3:
          contentJson = data[i].content && JSON.parse(data[i].content)
          item = {}
          item.messageType = parseInt(data[i].type)
          item.className = 'type-form'
          item.messageTitle = '表单提交成功'
          item.messageTime = data[i].add_time
          item.messageImg = 'icon-message-form'
          item.messageContent = contentJson.form_name
          item.messageForm = contentJson.form
          item.messageFormId = contentJson.form_id
          item.messageFormDataId = data[i].sub_id
          item.review_status = data[i].data_info.length
            ? data[i].data_info[0].form_data.review_status
            : 3
          item.review_switch = data[i].data_info
            ? data[i].data_info[0].form_data.review_switch
            : 0
          array.push(item)
          break
      }
    }
    return array
  }
  checkMoreMessageData = event => {
    let that = this
    let targetId = event.target.id
    switch (targetId) {
      case 'myMessage-system-message':
        if (
          that.data.systemBranch.isMore != 0 &&
          !that.data.systemBranch.onload
        ) {
          that.getMessageData(5, that.data.systemBranch.currentPage + 1)
          that.setData({
            'systemBranch.onload': true
          })
        }
        break
      case 'myMessage-interact-message':
        if (
          that.data.interactBranch.isMore != 0 &&
          !that.data.interactBranch.onload
        ) {
          that.getMessageData(6, that.data.interactBranch.currentPage + 1)
          that.setData({
            'interactBranch.onload': true
          })
        }
        break
      case 'myMessage-push-message':
        let pushBranchData = that.data.pushBranch
        if (pushBranchData.isMore != 0 && !pushBranchData.onload) {
          that.getMessageData(16, pushBranchData.currentPage + 1)
          that.setData({
            'pushBranch.onload': true
          })
        }
        break
    }
  }
  showMessageDetailForm = event => {
    let that = this
    let _form = event.currentTarget.dataset.form
    let _formId = event.currentTarget.dataset.formId
    let _formDataId = event.currentTarget.dataset.formDataId
    let _formData_list = [] // 该表单对应的字段详情数组
    app.setPageTitle('表单消息')
    app.sendRequest({
      url: '/index.php?r=pc/WebAppMgr/getForm',
      data: {
        app_id: app.globalData.appId,
        form_id: _formId
      },
      success: function (res) {
        _formData_list = res.data.field_arr
        for (let i in _formData_list) {
          if (_formData_list[i].field === 'region_id') {
            _formData_list.splice(i, 1)
          }
        }
        that.setData({ review_switch: res.data.review_switch })
        app.sendRequest({
          url: '/index.php?r=AppData/getFormData',
          data: {
            app_id: app.globalData.appId,
            form: _form,
            data_id: _formDataId
          },
          success: function (res) {
            let _array = [] // 临时存放表单提交详情的显示数据
            let _form_data = res.data['0'].form_data
            for (var key in _form_data) {
              let _index = -1 // 判断改表单提交详情对应在字段详情数组的位置
              for (var i = 0; i < _formData_list.length; i++) {
                if (_formData_list[i]['field'] == key) {
                  _index = i
                }
              }
              if (_index == -1) continue
              let _item = {} // 临时存放
              switch (parseInt(_formData_list[_index]['type'])) {
                case 1:
                  _item = {}
                  _item.dataType = 1
                  _item.dataName = _formData_list[_index]['name']
                  _item.dataContent = _form_data[key]
                  _array.push(_item)
                  break
                case 2:
                  _item = {}
                  _item.dataType = 2
                  _item.dataName = _formData_list[_index]['name']
                  _item.dataContent = _form_data[key]
                  _array.push(_item)
                  break
                case 3:
                  _item = {}
                  _item.dataType = 3
                  _item.dataName = _formData_list[_index]['name']
                  _item.dataContent = '富文本类型'
                  _array.push(_item)
                  break
              }
              _index++
            }
            that.setData({
              messageDetail: 3,
              messageDetailFormData: _array,
              form_data: _form_data
            })
          }
        })
      }
    })
  }
  confirmMessageDetailForm = () => {
    app.setPageTitle('表单提交信息')
    this.setData({
      messageDetail: 0,
      messageDetailFormData: []
    })
  }
  getReviewConfig = () => {
    app.sendRequest({
      url: '/index.php?r=AppConfig/GetAppDataReviewTextConfig',
      method: 'post',
      hideLoading: true,
      success: res => {
        this.setData({ reviewList: res.data })
      }
    })
  }
  bindplay = e => {
    let dataset = e.currentTarget.dataset
    let tag = dataset.tag
    let index = dataset.index
    let id = dataset.id
    let videoList = this.data.messageDetailFormData[tag].dataContent
    let contextData = this.data.contextData || {}
    Taro.showLoading({ title: '加载中' })
    videoList[index].virtual = videoList[index].fileName
    if (!contextData[id]) {
      contextData[id] = Taro.createVideoContext(id)
    }
    this.setData({
      contextData: contextData,
      [`messageDetailFormData[${tag}].dataContent`]: videoList
    })
    setTimeout(() => {
      contextData[id].play()
      contextData[id].requestFullScreen()
      Taro.hideLoading()
    }, 600)
  }
  bindPlayVideo = e => {
    let id = e.currentTarget.dataset.id
    let contextData = this.data.contextData || {}
    if (Object.keys(contextData).length > 0) {
      Object.keys(contextData).forEach((val, key) => {
        if (id != val) contextData[val].pause()
      })
    }
  }

  render() {
    const {
      showGetUserInfo,
      messageType,
      systemBranch,
      reviewList,
      messageDetail,
      messageDetailFormData,
      review_switch,
      form_data
    } = this.state
    return (
      <div className="official-page my-form-message">
        <TopNav title="表单提交信息"/>
        <div className="myMessage-wrap page" id="myMessage">
          {messageDetail == 0 && (
            <div className="myMessage-content-container">
              <ScrollView
                id="myMessage-system-message"
                className={
                  'myMessage-content ' + (messageType == 5 ? 'active' : '')
                }
              scroll-y="true"
              lowerThreshold="116"
              bindscrolltolower={this.checkMoreMessageData}
              >
                {systemBranch.data.map((item, index) => {
                  return (
                    <React.Fragment key={index}>
                      {item.messageType == 3 && (
                        <div
                          className={'message-item ' + item.className}
                          data-form={item.messageForm}
                          data-form-id={item.messageFormId}
                          data-form-data-id={item.messageFormDataId}
                          onClick={this.showMessageDetailForm}
                        >
                          <div className="message-title">
                            {item.messageTitle}
                          </div>
                          <div className="message-time">
                            {item.messageTime}
                          </div>
                          <div className="message-img">
                            <div
                              className={'ico-moon ' + item.messageImg}
                            ></div>
                          </div>
                          <div className="message-content">
                            <div className="message-price">
                              <div className="message-price-text">
                                {item.messageContent}
                              </div>
                              {(item.review_status ||
                                item.review_status >= 0) &&
                                item.review_switch == 1 && (
                                  <div className="message-price-text">
                                    状态：
                                    <span
                                      className={
                                        item.review_status == 0
                                          ? ''
                                          : item.review_status == 1
                                            ? 'success-examine'
                                            : 'faile-examine'
                                      }
                                    >
                                      {item.review_status == 0
                                        ? reviewList.applying_text || '待审核'
                                        : item.review_status == 1
                                          ? reviewList.apply_passed_text ||
                                          '审核通过'
                                          : reviewList.apply_unpassed_text ||
                                          '审核不通过'}
                                    </span>
                                  </div>
                                )}
                            </div>
                          </div>
                        </div>
                      )}
                    </React.Fragment>
                  )
                })}
                {!systemBranch.data.length && (
                  <div>
                    <div className="request-none">
                      <img
                        src="http://cdn.jisuapp.cn/static/webapp/images/request-none.png"
                        mode="widthFix"
                      />
                      <div>暂无数据~</div>
                    </div>
                  </div>
                )}
              </ScrollView>
            </div>
          )}
          {/*  详情  */}
          {messageDetail == 3 && (
            <div className="myMessage-detail-form">
              <div className="myMessage-form-list">
                {messageDetailFormData.map((item, index) => {
                  return (
                    <div className="myMessage-form-item" key={index}>
                      <div className="data-name">{item.dataName}</div>
                      {item.dataType != 2 && item.dataType != 12 ? (
                        <div className="data-content">{item.dataContent}</div>
                      ) : item.dataType == 2 ? (
                        <React.Fragment>
                          {pictureWxsModule.isArray(item.dataContent) ? (
                            <React.Fragment>
                              {item.dataContent.map((pic, index) => {
                                return (
                                  <img
                                    key
                                    className="data-img"
                                    src={pic}
                                  />
                                )
                              })}
                            </React.Fragment>
                          ) : (
                              <React.Fragment>
                                <img
                                  key
                                  className="data-img"
                                  src={item.dataContent}
                                />
                              </React.Fragment>
                            )}
                        </React.Fragment>
                      ) : (
                            item.dataType == 12 && (
                              <React.Fragment>
                                <div className="data-content">
                                  {item.dataContent.map((videoItem, videoIndex) => {
                                    return (
                                      <div className="video-item" key={index}>
                                        <video
                                          id={'wxParse' + videoIndex}
                                          className="video"
                                          poster={videoItem.previewImageUrl}
                                          src={videoItem.fileName}
                                          data-id={'wxParse' + videoIndex}
                                          onPlay={this.bindPlayVideo}
                                          controls={true}
                                        >
                                          {/* TODO */}
                                          <CoverView
                                            className="controls"
                                            data-tag={index}
                                            data-index={videoIndex}
                                            hidden={
                                              videoItem.fileName ==
                                              videoItem.virtual
                                            }
                                            data-id={'wxParse' + videoIndex}
                                            onClick={this.bindplay}
                                          ></CoverView>
                                        </video>
                                      </div>
                                    )
                                  })}
                                </div>
                              </React.Fragment>
                            )
                          )}
                    </div>
                  )
                })}
              </div>
              {review_switch == 1 && (
                <div className="myMessage-form-list">
                  <div className="myMessage-form-item">
                    <div className="data-name">状态</div>
                    <div className="data-content">
                      {form_data.review_status == 0
                        ? reviewList.applying_text || '待审核'
                        : form_data.review_status == 1
                          ? reviewList.apply_passed_text || '审核通过'
                          : reviewList.apply_unpassed_text || '审核不通过'}
                    </div>
                  </div>
                  {form_data.review_result && (
                    <div className="myMessage-form-item">
                      <div className="data-name">备注</div>
                      <div className="data-content">
                        {form_data.review_result}
                      </div>
                    </div>
                  )}
                </div>
              )}
              <div
                className="myMessage-form-confirm"
                onClick={this.confirmMessageDetailForm}
              >
                关闭
              </div>
            </div>
          )}
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/official-page/my-form-message/MyFormMessage.jsx